import { useEffect, useState } from "react";
import { PlusIcon } from "lucide-react";

import { Column, TopbarContainer, TopbarTitle } from "@/components";
import { CompaniesFiltersAndTable } from "@/components/companies/page/CompaniesFiltersAndTable";
import { CreateCompanyDialog } from "@/components/companies/page/CreateCompanyDialog";
import { Button } from "@/components/ui/button";

import { useSetTitle } from "@/hooks/useSetTitle";
import { useGetCachedCompaniesSummary } from "@/hooks/sets/useGetCachedCompaniesSummary";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const CompaniesPage = () => {
  const cachedCompanies = useGetCachedCompaniesSummary();
  const [isCreateCompanyDialogOpen, setIsCreateCompanyDialogOpen] =
    useState(false);

  useSetTitle({
    title: "Companies",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.COMPANIES);
  }, []);

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Companies</TopbarTitle>
        <Button
          className="rounded-full"
          onClick={() => {
            setIsCreateCompanyDialogOpen(true);
          }}
        >
          <PlusIcon className="h-4 w-4" />
          Create new company
        </Button>
      </TopbarContainer>
      <CompaniesFiltersAndTable
        className="min-h-0 p-6"
        companies={cachedCompanies}
      />
      <CreateCompanyDialog
        onOpenChange={setIsCreateCompanyDialogOpen}
        onSuccess={() => {
          setIsCreateCompanyDialogOpen(false);
        }}
        open={isCreateCompanyDialogOpen}
      />
    </Column>
  );
};
